import { render } from "./BackToStudentUiButton.vue?vue&type=template&id=84767768&scoped=true"
import script from "./BackToStudentUiButton.vue?vue&type=script&lang=js"
export * from "./BackToStudentUiButton.vue?vue&type=script&lang=js"

import "./BackToStudentUiButton.vue?vue&type=style&index=0&id=84767768&lang=scss&scoped=true"

import exportComponent from "/Volumes/TRENTDEVELOPMENT/www/classmarker_pre_release_production/web_apps/test-interface/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-84767768"]])

export default __exports__